import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessingReassuranceComponent} from "app_sasha/shared/components/processing-reassurance/processing-reassurance.component";
import { SashaBreadcrumbModule } from "app_sasha/shared/components/breadcrumb/sasha-breacrumb.module";
import { BookingsListModule } from "app_sasha/pages/booking-search-result/components/bookings-list/booking-list.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { ConfirmDialogModule } from "libraries/component/dialogs/confirm-dialog/confirm-dialog.module";
import { LoaderModule } from "libraries/component/loader/loader.module";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [ProcessingReassuranceComponent],
  exports: [
    ProcessingReassuranceComponent,
  ],
  imports: [
    CommonModule,
    SashaBreadcrumbModule,
    MatTabsModule,
    BookingsListModule,
    BtnModule,
    NotificationModule,
    MatDialogModule,
    ConfirmDialogModule,
    LoaderModule,
  ]
})
export class ProcessingReassuranceModule { }
